"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarknetCommit__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        type: "constructor",
        inputs: [
            {
                name: "_starknetCore",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "commit",
        inputs: [
            {
                name: "authStrategy",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "_hash",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "payable",
    },
    {
        type: "function",
        name: "starknetCore",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract IStarknetCore",
            },
        ],
        stateMutability: "view",
    },
];
const _bytecode = "0x60a060405234801561001057600080fd5b5060405161034038038061034083398101604081905261002f91610040565b6001600160a01b0316608052610070565b60006020828403121561005257600080fd5b81516001600160a01b038116811461006957600080fd5b9392505050565b6080516102af610091600039600081816040015261013d01526102af6000f3fe6080604052600436106100295760003560e01c806339e730ab1461002e5780635bf56bc41461008b575b600080fd5b34801561003a57600080fd5b506100627f000000000000000000000000000000000000000000000000000000000000000081565b60405173ffffffffffffffffffffffffffffffffffffffff909116815260200160405180910390f35b61009e6100993660046101e1565b6100a0565b005b60408051600280825260608201835260009260208301908036833701905050905033816000815181106100d5576100d5610203565b60200260200101818152505081816001815181106100f5576100f5610203565b60209081029190910101526040517f3e3aa6c500000000000000000000000000000000000000000000000000000000815273ffffffffffffffffffffffffffffffffffffffff7f00000000000000000000000000000000000000000000000000000000000000001690633e3aa6c59034906101989087907f017dd2cbe677d6dda22dd4a01edec54ba307cd2b1f7d130707ba5a29cc019c1d908790600401610232565b60206040518083038185885af11580156101b6573d6000803e3d6000fd5b50505050506040513d601f19601f820116820180604052508101906101db9190610289565b50505050565b600080604083850312156101f457600080fd5b50508035926020909101359150565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b60006060820185835260208560208501526060604085015281855180845260808601915060208701935060005b8181101561027b5784518352938301939183019160010161025f565b509098975050505050505050565b60006020828403121561029b57600080fd5b505191905056fea164736f6c6343000818000a";
const isSuperArgs = (xs) => xs.length > 1;
class StarknetCommit__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_starknetCore, overrides) {
        return super.deploy(_starknetCore, overrides || {});
    }
    getDeployTransaction(_starknetCore, overrides) {
        return super.getDeployTransaction(_starknetCore, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.StarknetCommit__factory = StarknetCommit__factory;
StarknetCommit__factory.bytecode = _bytecode;
StarknetCommit__factory.abi = _abi;
